// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2j-dK","content":"LayoutSettings_content__2HPuI"};